/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import SportsFilters from './SportsFilters/SportsFilters';
import NumberFilters from './NumberFilters/NumberFilters';
import RacingFilters from './RacingFilters/RacingFilters';
import { Dispatch, RootState } from 'src/configs/store';

function Filter () {
  const history = useHistory();
  const dispatch = useDispatch<Dispatch>();
  const { product } = useSelector((state:RootState) => state.filters);

  useEffect(() => {
    if (product){
      if (history.location.pathname.includes('/sports-betting') && product!== 'sports') {
        dispatch.filters.updateProduct('sports');
      } else if (history.location.pathname.includes('/lotto') && product!== 'lotto') {
        dispatch.filters.updateProduct('numbers');
      } else if (history.location.pathname.includes('/racing') && product!== 'racing'){
        dispatch.filters.updateProduct('racing');
      }
    }
  }, [history.location.pathname, product]);

  const renderFilter = () => {
    if (history.location.pathname.includes('/lotto')) {
      return <NumberFilters />;
    } else if (history.location.pathname.includes('/sports-betting')) {
      return <SportsFilters />;
    } else if (history.location.pathname.includes('/racing')) {
      return <RacingFilters />;
    } else {
      return null;
    }
  };

  return renderFilter();
}

export default Filter;
